module.exports = __webpack_public_path__ + "img/wenti_banner_tr.4bd65919.jpg";